import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import FestifyLogo from '../../components/FestifyLogo';
import { apiValidateRsvpProtocol } from '../../services/api';

function formatDate(dateString) {
  if (!dateString) return '-';

  return new Date(dateString).toLocaleString('pt-BR', {
    dateStyle: 'full',
    timeStyle: 'short',
  });
}

function translateStatus(status) {
  if (status === 'confirmed') return 'Confirmado';
  if (status === 'pending') return 'Pendente';
  if (status === 'declined') return 'Recusado';
  return status || 'Desconhecido';
}

export default function InviteValidate() {
  const { protocol } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [data, setData] = useState(null);

  useEffect(() => {
    async function validateProtocol() {
      setLoading(true);
      setError('');

      const response = await apiValidateRsvpProtocol(protocol || '');

      if (response.error) {
        setError(response.error);
      } else {
        setData(response);
      }

      setLoading(false);
    }

    validateProtocol();
  }, [protocol]);

  const statusInfo = useMemo(() => {
    const current = data?.validation?.status;

    if (current === 'confirmed') {
      return { label: 'Entrada liberada', className: 'ok' };
    }

    if (current === 'pending') {
      return { label: 'Aguardando confirmação', className: 'warn' };
    }

    if (current === 'declined') {
      return { label: 'Entrada não liberada', className: 'blocked' };
    }

    return { label: 'Status desconhecido', className: 'warn' };
  }, [data]);

  return (
    <main className="validate-page">
      <header className="validate-header">
        <FestifyLogo />
        <Link to="/" className="ghost-btn">Voltar</Link>
      </header>

      <section className="validate-card">
        <p className="festify-eyebrow">Validador de convite</p>
        <h1>Conferência de protocolo</h1>

        {loading && <p className="loading-text">Validando protocolo...</p>}

        {!loading && error && (
          <div className="api-error">
            {error}
          </div>
        )}

        {!loading && data && (
          <>
            <div className={`validate-status ${statusInfo.className}`}>
              <strong>{statusInfo.label}</strong>
              <p>{data.message}</p>
            </div>

            <div className="validate-grid">
              <article>
                <h2>Protocolo</h2>
                <p>{data.validation?.protocol || '-'}</p>
              </article>
              <article>
                <h2>Convidado</h2>
                <p>{data.guest?.name || '-'}</p>
              </article>
              <article>
                <h2>Status RSVP</h2>
                <p>{translateStatus(data.validation?.status)}</p>
              </article>
              <article>
                <h2>Total de pessoas</h2>
                <p>{Number(data.guest?.companions || 0) + 1}</p>
              </article>
            </div>

            <div className="validate-event-box">
              <h2>Evento</h2>
              <p><strong>Título:</strong> {data.event?.title || '-'}</p>
              <p><strong>Data:</strong> {formatDate(data.event?.eventDate)}</p>
              <p><strong>Local:</strong> {data.event?.location || '-'}</p>
              <p><strong>Conferido em:</strong> {formatDate(data.validation?.checkedAt)}</p>
            </div>
          </>
        )}
      </section>
    </main>
  );
}
